export default __webpack_public_path__ + "static/media/mayday-hero-imagery.ac64e2c3.png";